import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";

export interface TitleProps {
  internalContactsLength?: number;
  title?: string;
}

function TitleComponent(props: TitleProps) {
  const { internalContactsLength, title } = props;
  return (
    <Flex vertical>
      {/* Give fontSize using fs later */}
      <Flex>
        <TypographyText fs="16" strong>
          {title}
        </TypographyText>
        {props.internalContactsLength ? (
          <TypographyText
            fs="16"
            style={{ color: "var(--gray-7)", fontWeight: "normal" }}
          >
            ({internalContactsLength})
          </TypographyText>
        ) : null}
      </Flex>
    </Flex>
  );
}

export { TitleComponent };
